export const normalizeSrc = (input: unknown): string => {
  if (typeof input === 'string') return input;
  if (input instanceof URL) return input.toString();
  if (
    typeof input === 'number' ||
    typeof input === 'boolean' ||
    typeof input === 'bigint'
  ) {
    return String(input);
  }
  if (input && typeof input === 'object') {
    const maybeSrc = input as { src?: unknown; default?: unknown };
    const s = maybeSrc.src ?? maybeSrc.default ?? null;
    if (typeof s === 'string') return s;
  }
  return '';
};

export const isSvgSrc = (u?: unknown): boolean => {
  const [path = ''] = normalizeSrc(u).trim().toLowerCase().split(/[?#]/);
  return path.endsWith('.svg');
};
